import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing shadow" }
const _hoisted_4 = { class: "p-0 d-flex justify-content-between gap-3" }
const _hoisted_5 = { class: "localizations" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex gap-3"
}
const _hoisted_7 = ["data-bs-target"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = {
  key: 0,
  class: "text-center w-100"
}
const _hoisted_12 = {
  key: 1,
  class: "text-end w-100"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between gap-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "position-relative" }
const _hoisted_16 = {
  type: "submit",
  class: "ms-auto outlined default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16"
}
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "py-4" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "text-muted mt-10" }
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_BlockForm = _resolveComponent("BlockForm")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.locales.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                        return (_openBlock(), _createBlock(_component_country_flag, {
                          key: locale,
                          country: locale,
                          class: _normalizeClass([[{ 'opacity-25': _ctx.lang !== locale }], "cursor-pointer"]),
                          onClick: ($event: any) => (_ctx.changeLang(locale)),
                          title: _ctx.$t(`feature.contents.$lang.${locale}`)
                        }, null, 8 /* PROPS */, ["country", "class", "onClick", "title"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", {
                "data-bs-toggle": "modal",
                "data-bs-target": `#confirmModal-${_ctx.block.id}`,
                class: "align-items-center bg-danger-subtle d-inline-flex fs-3 h-50 justify-content-center rounded-circle text-danger w-50 cursor-pointer"
              }, [..._hoisted_9], 8 /* PROPS */, _hoisted_7)
            ]),
            _createVNode(_component_BlockForm, {
              block: _ctx.local_block,
              update: true,
              submitted: _ctx.submitted,
              lang: _ctx.lang,
              errors: _ctx.errors
            }, null, 8 /* PROPS */, ["block", "submitted", "lang", "errors"]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_SpinnerLoading)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.edited)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createCommentVNode(" DISCARD "),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args))),
                            class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                          }, [
                            _hoisted_14,
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('feature.contents.$blocks.discard_changes')), 1 /* TEXT */)
                          ]),
                          _createCommentVNode(" SAVE "),
                          _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.$t('feature.contents.$blocks.save')), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
            ])
          ], 32 /* NEED_HYDRATION */)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createCommentVNode("<div class=\"py-4\" :class=\"[{ 'opacity-25': edited }]\">\n                <template v-if=\"block.type === 'text'\">\n                    <h5>{{ block.subtitle![lang] }}</h5>\n                    <p>{{ block.value![lang] }}</p>\n                </template>\n                <template v-if=\"block.type === 'image'\">\n                    <img :src=\"block.value![lang]\" :alt=\"block.subtitle![lang]\">\n                    <p class=\"text-muted mt-10\"> {{ block.subtitle![lang] }}</p>\n                </template>\n                <template v-if=\"block.type === 'html'\">\n                    <h5>{{ block.subtitle![lang] }}</h5>\n                    <div v-html=\"block.value![lang]\"></div>\n                </template>\n            </div> "),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.block.type === 'text')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.local_block.subtitle![_ctx.lang]), 1 /* TEXT */),
                _createElementVNode("p", null, _toDisplayString(_ctx.local_block.value![_ctx.lang]), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          (_ctx.block.type === 'image')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("img", {
                  src: _ctx.local_block.value![_ctx.lang],
                  alt: _ctx.local_block.subtitle![_ctx.lang]
                }, null, 8 /* PROPS */, _hoisted_19),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.local_block.subtitle![_ctx.lang]), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" <template v-if=\"block.type === 'video'\">\n                    <iframe :src=\"local_block.value\" frameborder=\"0\" class=\"d-block h-100 ratio-16x9\"></iframe>\n                    <p class=\"text-muted mt-10\"> {{ local_block.subtitle }}</p>\n                </template> "),
          (_ctx.block.type === 'html')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.local_block.subtitle![_ctx.lang]), 1 /* TEXT */),
                _createElementVNode("div", {
                  innerHTML: _ctx.local_block.value![_ctx.lang]
                }, null, 8 /* PROPS */, _hoisted_21)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      id: `confirmModal-${_ctx.block.id}`,
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteBlock())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["id", "title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}